import React from 'react';
import CustomDaySelector from "../../../../../../../../components/CustomDaySelector";
import CustomTimePicker from "../../../../../../../../components/CustomTimePicker";
import {CustomCheckbox} from "../../../../../../../../components/CustomCheckbox";
import {ALL_TIME_NAME} from "../Model/Model";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const WeeklyRecurrenceScope = ({ t, rule, updateRule, emptyFields, isValid, disabled }) => {

    return (
        <>
            <div className='col-12 d-flex justify-content-center px-0 input-padding-bottom'>
                <CustomDaySelector
                    id="cb_wrs_day_selector"
                    dayArray={rule?.dayArray}
                    setDayArray={(updater) => {
                        const currentArray = rule?.dayArray || [];
                        const newValue = updater(currentArray);
                        updateRule('dayArray', newValue);
                    }}
                    required={true}
                    emptyFields={emptyFields}
                    readonly={disabled}
                />
            </div>

            <div className="col-12 py-2 px-0">
                <CustomCheckbox
                    id={'cb_wrs_de_select_all_time'}
                    trans={t('select_all_time')}
                    name={ALL_TIME_NAME}
                    checked={rule.allTime}
                    onChange={(e) => updateRule(e.target.name, !rule.allTime)}
                    marginbutton={true}
                    disabled={disabled}
                />
            </div>
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 px-1'>
                <CustomTimePicker
                    title={t('start_time')}
                    name='startTime'
                    value={rule?.startTime}
                    handleChange={(value) => {
                        updateRule('startTime', value)
                    }}
                    disabled={disabled ? disabled : rule.allTime}
                    ampm={false}
                    required
                    id={'tp_wrs_start_time'}
                    actions={['accept', 'cancel']}
                    emptyFields={emptyFields}
                    formatValue={true}
                    isValid={isValid}
                    isValidText={"this_cant_have_at_least_time_to_from_or_same_time"}

                />
            </div>
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 px-1'>
                <CustomTimePicker
                    title={t('end_time')}
                    name='endTime'
                    value={rule?.endTime}
                    handleChange={(value) => {
                        updateRule('endTime', value)
                    }}
                    disabled={disabled ? disabled : rule.allTime}
                    ampm={false}
                    required
                    id={'tp_wrs_end_time'}
                    actions={['accept', 'cancel']}
                    emptyFields={emptyFields}
                    formatValue={true}
                    isValid={isValid}
                    isValidText={"this_cant_have_at_least_time_to_from_or_same_time"}
                />
            </div>
        </>
    );
};

export default WeeklyRecurrenceScope;
